var $60690790bf4c1c6a$exports = {};
$60690790bf4c1c6a$exports = {
  "buttonLabel": "Kuva soovitused",
  "countAnnouncement": function countAnnouncement(args, formatter) {
    return "".concat(formatter.plural(args.optionCount, {
      one: function one() {
        return "".concat(formatter.number(args.optionCount), " valik");
      },
      other: function other() {
        return "".concat(formatter.number(args.optionCount), " valikud");
      }
    }), " saadaval.");
  },
  "focusAnnouncement": function focusAnnouncement(args, formatter) {
    return "".concat(formatter.select({
      true: function _true() {
        return "Sisestatud r\xFChm ".concat(args.groupTitle, ", valikuga ").concat(formatter.plural(args.groupCount, {
          one: function one() {
            return "".concat(formatter.number(args.groupCount), " valik");
          },
          other: function other() {
            return "".concat(formatter.number(args.groupCount), " valikud");
          }
        }), ". ");
      },
      other: ""
    }, args.isGroupChange)).concat(args.optionText).concat(formatter.select({
      true: ", valitud",
      other: ""
    }, args.isSelected));
  },
  "listboxLabel": "Soovitused",
  "selectedAnnouncement": function selectedAnnouncement(args) {
    return "".concat(args.optionText, ", valitud");
  }
};
export { $60690790bf4c1c6a$exports as default };